import {TranslationScope} from '../models/core/translationScope';
import {Injectable, InjectionToken, Optional} from '@angular/core';

@Injectable()
export class TranslationScopeRef {
  constructor(@Optional() public ref?: TranslationScope) {
  }

  public toString(): string {
    return this.ref ? this.ref.toString() : '';
  }
}

export const TRANSLATION_SCOPE_REF = new InjectionToken<TranslationScopeRef>('TranslationScopeRef');
